"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKpiDrillTarget = void 0;
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
function validateKpiDrillTarget(drill, availableLegacyDashboards) {
    var relevantDashboard = availableLegacyDashboards.find(function (dash) {
        return sdk_model_1.areObjRefsEqual(dash.ref, drill.target);
    });
    if (!relevantDashboard) {
        throw Error("Dashboard with ref " + sdk_model_1.objRefToString(drill.target) + " was not found.");
    }
    if (!relevantDashboard.tabs.some(function (tab) { return tab.identifier === drill.tab; })) {
        throw Error("Dashboard with ref " + sdk_model_1.objRefToString(drill.target) + " does not contain tab with identifier " + drill.tab + ".");
    }
}
exports.validateKpiDrillTarget = validateKpiDrillTarget;
//# sourceMappingURL=kpiDrillValidationUtils.js.map